/**
 * @copyright Copyright (c) 2020, KNE GmbH.
 *
 * @author Jan Duwe <jan.duwe@kne.de>
 *
 * @license AGPL-3.0
 *
 * This code is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License, version 3,
 * as published by the Free Software Foundation.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License, version 3,
 * along with this program.  If not, see <http://www.gnu.org/licenses/>
 *
 */

import { MutationTree } from "vuex";
import router from '@/router'
import { IRootState } from "../../model/RootState";
import { ISnackbarState } from "../../model/SnackbarState";


export const mutations: MutationTree<ISnackbarState> = {
    showSnackbar (state: any, message: string) {
        state.snackbar = message
    },
}